export namespace Dashboard {
    export interface IComponentBaseProps<ReportOptionsT> {
        reportOptions?: ReportOptionsT;
        reportMode?: boolean
    }

    export interface IComponentTimed {
        referenceTime?: string;
    }
}

